<ion-header>
  <ion-toolbar>
    <ion-title>
      <ion-icon name="pricetag-outline" style="vertical-align: middle; margin-right: 8px"></ion-icon>
      {{ "OFFICE.OFFER.DETAILS.MODAL.TITLE" | translate }}
    </ion-title>
    <ion-buttons slot="end">
      <ion-button fill="clear" (click)="closeModal()">
        <ion-icon name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <!-- Office Information -->
  <ion-card class="office-info-card">
    <ion-card-header>
      <ion-text class="ion-margin-bottom">
        <h2 style="display: flex; align-items: center; justify-content: center; gap: 8px">
          <ion-icon name="business-outline" style="font-size: 1.5rem"></ion-icon>
          {{ selectedOffice.name | localized }}
        </h2>
      </ion-text>
      <h4 style="display: flex; align-items: center; justify-content: center; gap: 6px; color: var(--ion-color-medium)">
        <ion-icon name="location-outline"></ion-icon>
        {{ selectedOffice.address | localized }}
      </h4>
    </ion-card-header>
    <ion-card-content>
      <div style="display: flex; flex-direction: column; align-items: center">
        <h3 style="margin-bottom: 0.5rem; color: var(--ion-color-medium)">
          {{ "OFFICE.OFFER.DETAILS.MODAL.TOTAL.PRICE" | translate }}:
        </h3>
        <ion-text color="success">
          <h1 style="font-size: 2.2rem; font-weight: 700; margin: 0; letter-spacing: 1px">
            <ion-icon name="cash-outline" style="font-size: 2rem; margin-right: 6px"></ion-icon>
            {{ selectedOffice.offerDetails.printTotalPrice }} {{ "CURRENCY.TEXT" | translate }}
          </h1>
        </ion-text>
        <ion-text color="medium">
          <h4 class="commission-text">
            <ion-icon class="commission-icon" name="trending-up-outline"></ion-icon>
            {{ "OFFICE.OFFER.DETAILS.MODAL.COMMISSION" | translate }}:
            <span class="commission-value">{{ selectedOffice.offerDetails.commission }} {{ "CURRENCY.TEXT" | translate }}</span>
          </h4>
        </ion-text>
      </div>
    </ion-card-content>
  </ion-card>

  <!-- Table for Offer Details Per File -->
  <ion-card class="file-offers-card">
    <ion-card-content>
      <ion-grid class="ion-hide-md-down">
        <ion-row class="table-header">
          <ion-col size="2">
            <p class="table-text">{{ "OFFICE.OFFER.DETAILS.MODAL.FILE.NAME" | translate }}</p>
          </ion-col>
          <ion-col size="2">
            <p class="table-text">{{ "OFFICE.OFFER.DETAILS.MODAL.FILE.PAGES" | translate }}</p>
          </ion-col>
          <ion-col size="2">
            <p class="table-text">{{ "OFFICE.OFFER.DETAILS.MODAL.FILE.COPIES" | translate }}</p>
          </ion-col>
          <ion-col size="2">
            <p class="table-text">{{ "OFFICE.OFFER.DETAILS.MODAL.FILE.PAPERS.PRICE.TITLE" | translate }}</p>
          </ion-col>
          <ion-col size="2">
            <p class="table-text">{{ "OFFICE.OFFER.DETAILS.MODAL.FILE.EXTRAS.PRICE.TITLE" | translate }}</p>
          </ion-col>
          <ion-col size="2">
            <p class="table-text">{{ "OFFICE.OFFER.DETAILS.MODAL.FILE.PRICE.TOTAL" | translate }}</p>
          </ion-col>
        </ion-row>

        <ion-row *ngFor="let file of selectedOffice?.offerDetails?.files" class="table-row">
          <ion-col size="2">{{ getFileName(file) }}</ion-col>
          <ion-col size="2">{{ file.pagesQuantity }}</ion-col>
          <ion-col size="2">{{ file.copies }}</ion-col>
          <ion-col size="2">{{ file.paperTypeTotalPrice }}</ion-col>
          <ion-col size="2">{{ file.extrasTotalPrice }}</ion-col>
          <ion-col size="2">
            <ion-text color="primary">
              <h4 style="margin: 0; font-weight: 600">{{ file.fileTotalPrice }} {{ "CURRENCY.TEXT" | translate }}</h4>
            </ion-text>
          </ion-col>
        </ion-row>
      </ion-grid>

      <ion-grid class="ion-hide-md-up">
        <ion-card *ngFor="let file of selectedOffice?.offerDetails?.files" class="file-card">
          <ion-card-content>
            <h5>
              <ion-icon name="document-outline" style="margin-right: 4px"></ion-icon>
              {{ "OFFICE.OFFER.DETAILS.MODAL.FILE.NAME" | translate }}: {{ getFileName(file) }}
            </h5>
            <h5>
              <ion-icon name="layers-outline" style="margin-right: 4px"></ion-icon>
              {{ "OFFICE.OFFER.DETAILS.MODAL.FILE.PAGES" | translate }}: {{ file.pagesQuantity }}
            </h5>
            <h5>
              <ion-icon name="copy-outline" style="margin-right: 4px"></ion-icon>
              {{ "OFFICE.OFFER.DETAILS.MODAL.FILE.COPIES" | translate }}: {{ file.copies }}
            </h5>
            <h5>
              <ion-icon name="albums-outline" style="margin-right: 4px"></ion-icon>
              {{ "OFFICE.OFFER.DETAILS.MODAL.FILE.PAPERS.PRICE.TITLE" | translate }}: {{ file.paperTypeTotalPrice }}
            </h5>
            <h5>
              <ion-icon name="add-circle-outline" style="margin-right: 4px"></ion-icon>
              {{ "OFFICE.OFFER.DETAILS.MODAL.FILE.EXTRAS.PRICE.TITLE" | translate }}: {{ file.extrasTotalPrice }}
            </h5>
            <h4 style="margin-top: 12px">
              <ion-icon name="cash-outline" style="margin-right: 4px"></ion-icon>
              {{ "OFFICE.OFFER.DETAILS.MODAL.FILE.PRICE.TOTAL" | translate }}:
              <ion-text color="primary">{{ file.fileTotalPrice }} {{ "CURRENCY.TEXT" | translate }}</ion-text>
            </h4>
          </ion-card-content>
        </ion-card>
      </ion-grid>
    </ion-card-content>
  </ion-card>

  <div class="continue-btn-container">
    <ion-button expand="block" color="primary" size="large" (click)="onContinue()">
      <ion-icon slot="start" name="arrow-forward-circle-outline"></ion-icon>
      {{ "COMMON.CONTINUE" | translate }}
    </ion-button>
  </div>
</ion-content>
